import React from "react";
import {Button, Col, Row, Spin} from "antd";
import "./OriginatorInformationPanel.scss";
import FieldValueVerticalCell from "components/general/FieldValueVerticalCell";
import {getVirtualAccountBalanceByVirtualAccId, linkOriginatorToDBS} from "../api/api";
import {displayError, displaySuccessMessageWithSeconds} from "../common/notifications";
import moment from "moment";
import Modal from "antd/lib/modal";
import DocumentOriginatorCorporateUploading from "./DocumentOriginatorCorporateUploading";

import {FormattedMessage} from "react-intl";
import withUseIntl from "components/withUseIntl";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {DbsChannelComponent} from "./DbsChannelComponent";

const confirm = Modal.confirm;
class OriginatorInformationPanel extends React.Component {

  state = {
    isUserDocumentOpen: false,
    showVABrdgx:false
  }
  handleCancelDocument = () => {
    this.setState({
      isUserDocumentOpen: false
    })
  }
  openDocumentModal = () => {
    this.setState({
      isUserDocumentOpen: true
    })
  }

  // buildBalanceStr = (balanceStr) => {
  //   if(balanceStr && balanceStr.includes(",")){
  //     let balanceArr = balanceStr.replace(/,/g,"\n");
  //     // let balanceArr = balanceStr.split(",");
  //     return balanceArr;
  //   } else{
  //     return balanceStr
  //   }
  // }

  selectedVaId = (vaId) =>{
    let selectedVaId = this.state.selectedVaId;
    this.setState({
      selectedVaId:vaId
    })
    getVirtualAccountBalanceByVirtualAccId(vaId,false).then(res =>{
      const intl = this.props.useIntl;
      let originator = this.props.originator;
      let virtualAccounts = originator.virtualAccounts;
      if(virtualAccounts) {
        virtualAccounts.forEach(item=>{
          if(res.balance) {
            if (item.id === vaId) {
              item.vaBalanceStr = res.balance;
              item.vaBalanceStrClaimed = res.claimedBalance;
            }
          }else {
            item.vaBalanceStr=[];
            item.vaBalanceStrClaimed=[];
          }
        })
      }
      this.props.updateOriginator (this.props.idxOfCurrentOrg,originator);
      this.setState({
        selectedVaId:null
      })

    }).catch(e=>{
      displayError(JSON.stringify(e));
      this.setState({
        selectedVaId:null
      })
    })
  }

  buildVaBalanceInfo = (id,virtualAccountNumber,vaBalanceStr) => {
    const intl = this.props.useIntl;
    if (!virtualAccountNumber) {
      return null;
    }
    if (vaBalanceStr) {

      let result = Object.entries(vaBalanceStr).map((k, v) => {
        let s = `${k}\n`;
        return s.replaceAll(",", ": ");
      })

      if (result.length == 0) {
        result = intl.formatMessage({id: "app.panel.beneficiaryinformationpanel.virtualaccountBalance.empty"});
      }

      return (
          <FieldValueVerticalCell
              style={{whiteSpace: "pre-line"}}
              className="bp-table-cell"
              title={intl.formatMessage({id: "app.page.dashboardrxpage.balanceonhold"})}
              value={result}
          />
      );
    } else {
      if (this.state.selectedVaId === id) {
        return <Spin/>;
      } else {
        return (
            <>
              <p class="field-value-cell-header" style={{paddingBottom: "6px", marginBottom: 0}}>{intl.formatMessage({id: "app.page.dashboardrxpage.balanceonhold"})}</p>
              <Button type={'link'} onClick={() => {
                this.selectedVaId(id);
              }}>{intl.formatMessage({id: "app.common.show"})}</Button>
            </>
        );
      }
    }
  }

  buildVaBalanceInfoClaimed = (id,virtualAccountNumber,vaBalanceStrClaimed) => {
    const intl = this.props.useIntl;
    if (!virtualAccountNumber) {
      return null;
    }
    if (vaBalanceStrClaimed) {

      let result = Object.entries(vaBalanceStrClaimed).map((k, v) => {
        let s = `${k}\n`;
        return s.replaceAll(",", ":");
      })

      if (result.length == 0) {
        result = intl.formatMessage({id: "app.panel.beneficiaryinformationpanel.virtualaccountBalance.empty"});
      }

      return (
          <FieldValueVerticalCell
              style={{whiteSpace: "pre-line"}}
              className="bp-table-cell"
              title={intl.formatMessage({id: "app.page.dashboardrxpage.claimedbalance"})}
              value={result}
          />
      );
    } else {
      if (this.state.selectedVaId === id) {
        return <Spin/>;
      } else {
        return (
            <FieldValueVerticalCell
                style={{whiteSpace: "pre-line"}}
                className="bp-table-cell"
                title={intl.formatMessage({id: "app.page.dashboardrxpage.claimedbalance"})}
                value={'-'}
            />
        );
      }
    }
  }


  buildVirtualAccountInfo = () => {
    const intl = this.props.useIntl;
    if(!this.props.originator.virtualAccounts) {
      return null;
    }
    if(this.props.originator.virtualAccounts.length == 0) {
      return (
          <>
            <div className="beneficiary-information-panel">
              <h6 className={"fw-600"}><FormattedMessage id="app.panel.beneficiaryinformationpanel.virtualaccount"/>
              </h6>
              <div className="bp-bordered-panel bp-margin-top-smallest-2">
                <Row gutter={16}>
                  <Col md={6} sm={8}>
                    <FieldValueVerticalCell
                        className="bp-table-cell"
                        title={intl.formatMessage({id: "app.panel.beneficiaryinformationpanel.virtualaccountLocation"})}
                        value={"-"}
                    />
                  </Col>
                  <Col md={6} sm={8}>
                    <FieldValueVerticalCell
                        className="bp-table-cell"
                        title={intl.formatMessage({id: "app.panel.beneficiaryinformationpanel.virtualaccountCurrency"})}
                        value={"-"}
                    />
                  </Col>
                  <Col md={6} sm={8}>
                    <FieldValueVerticalCell
                        className="bp-table-cell"
                        title={intl.formatMessage({id: "app.panel.beneficiaryinformationpanel.virtualaccountNumber"})}
                        value={"-"}
                    />
                  </Col>
                  <Col md={6} sm={8}>
                    <FieldValueVerticalCell
                        className="bp-table-cell"
                        title={intl.formatMessage({id: "app.panel.beneficiaryinformationpanel.virtualaccountName"})}
                        value={"-"}
                    />
                  </Col>
                  <Col md={6} sm={8}>
                    <FieldValueVerticalCell
                        className="bp-table-cell"
                        title={intl.formatMessage({id: "app.panel.beneficiaryinformationpanel.virtualaccountBalance"})}
                        value={"-"}
                    />
                  </Col>
                  <Col md={6} sm={8}>
                    <FieldValueVerticalCell
                        className="bp-table-cell"
                        title={intl.formatMessage({id: "app.panel.beneficiaryinformationpanel.virtualaccountStatus"})}
                        value={"-"}
                    />
                  </Col>
                </Row>
              </div>
            </div>
          </>
      )
    }

    if(this.props.originator.virtualAccounts.length > 0) {
      return (
          <>
            <div className="beneficiary-information-panel">
              <h6 className={"fw-600"}><FormattedMessage id="app.panel.beneficiaryinformationpanel.virtualaccount"/>
              </h6>
              <div className="bp-bordered-panel bp-margin-top-smallest-2">
                {
                  this.props.originator.virtualAccounts.map((item, i) => {
                    let location = '';
                    if(item.virtualAccountChannelCode=='DBS_HK' ) {
                      location ="Hong Kong"
                    } else if (item.virtualAccountChannelCode=='DBS_SG') {
                      location ="Singapore"
                    } else if (item.virtualAccountChannelCode=='SAHABAT_SAMPOERNA') {
                      location ="Indonesia"  
                    } else if (item.virtualAccountChannelCode=='FLASH_FX') {
                      location ="Australia"  
                    }

                    var virtualAccountNumber = null;
                    if(item.virtualAccountStatus=='UNVERIFIED' ) {
                      virtualAccountNumber = "-";
                    } else {
                      virtualAccountNumber = item.virtualAccountNumber;
                    }

                    var swift = null;
                    if (location === 'HK') {
                      swift = this.props.hkSourceAccountCurrency.bankSwift;
                    } else if (location === 'SG') {
                      swift = 'FAST transfer only';
                    } else {
                      swift = 'Local transfer only';
                    }

                    return (
                        <Row gutter={16}>
                          <Col md={6} sm={8}>
                            <FieldValueVerticalCell
                                className="bp-table-cell"
                                title={intl.formatMessage({id: "app.panel.beneficiaryinformationpanel.virtualaccountLocation"})}
                                value={location}
                            />
                          </Col>
                          <Col md={6} sm={8}>
                            <FieldValueVerticalCell
                                className="bp-table-cell"
                                title={intl.formatMessage({id: "app.panel.beneficiaryinformationpanel.virtualaccountCurrency"})}
                                value={item.currencies}
                            />
                          </Col>
                          <Col md={6} sm={8}>
                            <FieldValueVerticalCell
                                className="bp-table-cell"
                                title={intl.formatMessage({id: "app.panel.beneficiaryinformationpanel.virtualaccountNumber"})}
                                value={item.virtualAccountNumber}
                            />
                          </Col>
                          <Col md={6} sm={8}>
                            <FieldValueVerticalCell
                                className="bp-table-cell"
                                title={intl.formatMessage({id: "app.panel.beneficiaryinformationpanel.virtualaccountName"})}
                                value={item.virtualAccountName}
                            />
                          </Col>
                          <Col md={6} sm={8}>
                            {this.buildVaBalanceInfo(item.id,item.virtualAccountNumber,item.vaBalanceStr)}
                          </Col>
                          <Col md={6} sm={8}>
                            {this.buildVaBalanceInfoClaimed(item.id,item.virtualAccountNumber,item.vaBalanceStrClaimed)}
                          </Col>
                          <Col md={6} sm={8}>
                            <FieldValueVerticalCell
                                className="bp-table-cell"
                                title={intl.formatMessage({id: "app.panel.beneficiaryinformationpanel.virtualaccountStatus"})}
                                value={item.virtualAccountStatus}
                            />
                          </Col>

                          <Col md={6} sm={8}>
                            <FieldValueVerticalCell
                                className="bp-table-cell"
                                title={intl.formatMessage({id: "app.panel.beneficiaryinformationpanel.virtualaccountswift"})}
                                value={swift}
                            />
                          </Col>

                          {item.virtualAccountChannelCode=='FLASH_FX' && <Col md={6} sm={8}>
                            <FieldValueVerticalCell
                                className="bp-table-cell"
                                title={intl.formatMessage({id: "app.panel.beneficiaryinformationpanel.virtualaccount.bsbCode"})}
                                value={item.bsbCode}
                            />
                          </Col>}

                        </Row>
                    );
                  })
                }

              </div>
            </div>
          </>
      )
    }
  }

  showVABrdgx = () => {
    this.setState({
      showVABrdgx:true
    })
  }

  hideVABrdgx = () => {
    this.setState({
      showVABrdgx:false
    })
  }

  handleDbsAcc = () => {

    const intl = this.props.useIntl;
    confirm({
      title: <p> {intl.formatMessage({id:"app.panel.beneficiaryinformationpanel.doyouwantcreate.vabrdgx"})} </p>,
      onOk: () => {
        this.setState({
          isLoading: true
        });
        let originator = this.props.originator;
        let virtualDbsReq = {
          originatorId: originator.id,
          virtualAccountChannelCode: 'DBS_HK'
        };
        linkOriginatorToDBS(virtualDbsReq)
            .then(response => {
              let originator = this.props.originator;
              response.balanceStr='0.00';
              originator.virtualAccounts.push(response)

              this.props.updateOriginator(this.props.idxOfCurrentOrg,originator);
              this.setState({
                isLoading: false,
                showVABrdgx: false
              });
              displaySuccessMessageWithSeconds(intl.formatMessage({id:"app.common.successfully"}),3);
              return response;
            })
            .catch(error => {
              this.setState({
                isLoading: false,
                showVABrdgx: false
              });
              displayError(error.result);
            });
      }
    })
  }

  buildVAButton = () => {
    if(this.props.currentCustomer.accountType ==='PERSONAL') {
      return null;
    }
    if (!this.props.currentCustomer.enableVaLegs || !this.props.currentCustomer.enableVaLegs.includes('ORIGINATOR')) {
      return null;
    }
    if(this.props.currentUser && !this.props.currentUser.role.readOnly) {
      if(this.props.originator.virtualAccounts) {
        let checkDBSHKExisted = this.props.originator.virtualAccounts.find(item => item.virtualAccountChannelCode === 'DBS_HK');
        if (checkDBSHKExisted) {
          return null;
        }
      }
      return (<Button
          type="primary"
          onClick={() =>
              this.showVABrdgx()
          }
      >
        <FormattedMessage id="app.panel.beneficiaryinformationpanel.create.vabrdgx"/>
      </Button>)
    }
  }



  render() {
    const intl = this.props.useIntl;
    let originatorType = this.props.originator.originatorType;
    if (originatorType === "CORPORATE") {
      return (
          <div className={"originator-information-section"}>

            <div className="originator-information-panel">
              <h6 className={"fw-600"}><FormattedMessage id="app.panel.originatorinfomationpanel.bankaccount"/></h6>
              <div className="bp-bordered-panel bp-margin-top-smallest-2">
                <Row gutter={16}>
                  <Col md={6} sm={8}>
                    <FieldValueVerticalCell
                        className="bp-table-cell"
                        title={intl.formatMessage({id: "app.panel.originatorinfomationpanel.sendername"})}
                        value={this.props.originator.businessName}
                    />
                  </Col>
                  <Col md={6} sm={8}>
                    <FieldValueVerticalCell
                        className="bp-table-cell"
                        title={intl.formatMessage({id: "app.panel.originatorinfomationpanel.sendertype"})}
                        value={this.props.originator.originatorType}
                    />
                  </Col>
                  <Col md={6} sm={8}>
                    <FieldValueVerticalCell
                        className="bp-table-cell"
                        title={intl.formatMessage({id: "app.panel.originatorinfomationpanel.bankcountry"})}
                        value={this.props.originator.countryIncorporatedName}
                    />
                  </Col>
                  <Col md={6} sm={8}>
                    <FieldValueVerticalCell
                        className="bp-table-cell bp-margin-top-smallest"
                        title={intl.formatMessage({id: "app.panel.originatorinfomationpanel.businessnumber"})}
                        value={this.props.originator.businessNumber}
                    />
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col md={6} sm={8}>
                    <FieldValueVerticalCell
                        className="bp-table-cell bp-margin-top-smallest"
                        title={intl.formatMessage({id: "app.panel.originatorinfomationpanel.sourceoffunds"})}
                        value={this.props.originator.sourceOfFunds}
                    />
                  </Col>
                  <Col md={6} sm={8}>
                    <FieldValueVerticalCell
                        className="bp-table-cell bp-margin-top-smallest"
                        title={intl.formatMessage({id: "app.panel.originatorinfomationpanel.referencenumber"})}
                        value={this.props.originator.referenceNumber}
                    />
                  </Col>
                  <Col md={6} sm={8}>
                    <FieldValueVerticalCell
                        className="bp-table-cell bp-margin-top-smallest"
                        title={intl.formatMessage({id: "app.panel.originatorinfomationpanel.dateofcorporation"})}
                        value={moment(this.props.originator.dob).format("YYYY-DD-MM")}
                    />
                  </Col>
                  <Col md={6} sm={8}>
                    <FieldValueVerticalCell
                        className="bp-table-cell bp-margin-top-smallest"
                        title={intl.formatMessage({id: "app.panel.originatorinfomationpanel.businessnature"})}
                        value={this.props.industryName}
                    />
                  </Col>
                </Row>
              </div>
            </div>

            {this.buildVirtualAccountInfo()}

            <Modal title={intl.formatMessage({id: "app.panel.originatorinfomationpanel.businessprofile"})} visible={this.state.isUserDocumentOpen}
                   onCancel={this.handleCancelDocument}
                   width={800}
                   style={{ resize: "none" }}
                   footer={[
                       <Button onClick={this.handleCancelDocument}><FormattedMessage id="app.panel.originatorinfomationpanel.close"/></Button>
              ]}>
              <DocumentOriginatorCorporateUploading handleCorporateSubmit ={this.handleCorporateSubmit}
                                             originator={this.props.originator}
              />
            </Modal>
            {(this.props.currentUser && !this.props.currentUser.role.readOnly &&
            <div className="">
              <Button
                  type="primary"
                  onClick={() =>
                      this.props.onDeleteOriginatorClicked(this.props.originator)
                  }
              >
                {intl.formatMessage({id: "app.panel.originatorinfomationpanel.deletesender"})}
              </Button>
              <Button type="primary" onClick={this.openDocumentModal} style={{marginLeft: "10px"}} icon="upload" >{' '}<FormattedMessage id="app.panel.originatorinfomationpanel.uploadbusinessprofile"/></Button>

              <span> </span>
              <Button
                  type="primary"
                  onClick={() =>
                      this.props.edit(this.props.originator.id)
                  }
              >
                <FormattedMessage id="app.common.edit"/>
              </Button>
              <span> </span>
              {/*{this.buildVAButton()}*/}
              <Modal title={`${intl.formatMessage({id:"app.panel.beneficiaryinformationpanel.select.channel"})}`}
                     visible={this.state.showVABrdgx}
                     size={"sm"}
                     onOk ={this.handleDbsAcc}
                     onCancel={this.hideVABrdgx}
              >
                <DbsChannelComponent />
              </Modal>
            </div> )}
          </div>
      );
    }
    let idTypename = this.props.idTypes.find(item => item.code == this.props.originator.idType).value;
    return (
      <div className={"originator-information-section"}>
        <div className="originator-information-panel">
          <h6 className={"fw-600"}><FormattedMessage id="app.panel.originatorinfomationpanel.senderinformation"/></h6>
          <div className="bp-bordered-panel bp-margin-top-smallest-2">
            <Row gutter={16}>
              <Col md={6} sm={8}>
                <FieldValueVerticalCell
                  className="bp-table-cell"
                  title={intl.formatMessage({id: "app.panel.originatorinfomationpanel.sendername"})}
                  value={this.props.originator.displayName}
                />
              </Col>
              <Col md={6} sm={8}>
                <FieldValueVerticalCell
                  className="bp-table-cell"
                  title={intl.formatMessage({id: "app.panel.originatorinfomationpanel.sendertype"})}
                  value={this.props.originator.originatorType}
                />
              </Col>
              <Col md={6} sm={8}>
                <FieldValueVerticalCell
                  className="bp-table-cell"
                  title={intl.formatMessage({id: "app.panel.originatorinfomationpanel.sourceoffunds"})}
                  value={this.props.originator.sourceOfFunds}
                />
              </Col>
              <Col md={6} sm={8}>
                <FieldValueVerticalCell
                  className="bp-table-cell bp-margin-top-smallest"
                  title={intl.formatMessage({id: "app.panel.originatorinfomationpanel.referencenumber"})}
                  value={this.props.originator.referenceNumber}
                />
              </Col>
            </Row>
            <Row gutter={16}>
              <Col md={6} sm={8}>
                <FieldValueVerticalCell
                    className="bp-table-cell"
                    title={intl.formatMessage({id: "app.panel.originatorinfomationpanel.firstname"})}
                    value={this.props.originator.firstName}
                />
              </Col>
              <Col md={6} sm={8}>
                <FieldValueVerticalCell
                    className="bp-table-cell"
                    title={intl.formatMessage({id: "app.panel.originatorinfomationpanel.lastname"})}
                    value={this.props.originator.lastName}
                />
              </Col>
              <Col md={6} sm={8}>
                <FieldValueVerticalCell
                    className="bp-table-cell bp-margin-top-smallest"
                    title={intl.formatMessage({id: "app.panel.originatorinfomationpanel.dateofbirth"})}
                    value={moment(this.props.originator.dob).format("YYYY-MM-DD")}
                />
              </Col>
              <Col md={6} sm={8}>
                <FieldValueVerticalCell
                    className="bp-table-cell bp-margin-top-smallest"
                    title={intl.formatMessage({id: "app.panel.originatorinfomationpanel.nationality"})}
                    value={this.props.originator.nationalityName}
                />
              </Col>
            </Row>
            <Row gutter={16}>
              <Col md={6} sm={8}>
                <FieldValueVerticalCell
                    className="bp-table-cell"
                    title={intl.formatMessage({id: "app.panel.originatorinfomationpanel.residencecountry"})}
                    value={this.props.originator.countryOfResidenceName}
                />
              </Col>
              <Col md={6} sm={8}>
                <FieldValueVerticalCell
                    className="bp-table-cell bp-margin-top-smallest"
                    title={intl.formatMessage({id: "app.panel.originatorinfomationpanel.idtype"})}
                    value={idTypename}
                />
              </Col>

              <Col md={6} sm={8}>
                <FieldValueVerticalCell
                    className="bp-table-cell"
                    title={intl.formatMessage({id: "app.panel.originatorinfomationpanel.idnumber"})}
                    value={this.props.originator.idNumber}
                />
              </Col>
            </Row>
          </div>
        </div>

        {this.buildVirtualAccountInfo()}

        <div className="">
          {(this.props.currentUser && !this.props.currentUser.role.readOnly &&
          <Button
            type="primary"
            onClick={() =>
              this.props.onDeleteOriginatorClicked(this.props.originator)
            }
          >
            <FormattedMessage id="app.panel.originatorinfomationpanel.deletesender"/>
          </Button>)}
          <span> </span>
          {(this.props.currentUser && !this.props.currentUser.role.readOnly &&
          <Button
              type="primary"
              onClick={() =>
                  this.props.edit(this.props.originator.id)
              }
          >
            <FormattedMessage id="app.common.edit"/>
          </Button>)}
          <span> </span>
          {/*{this.buildVAButton()}*/}
          <Modal title={`${intl.formatMessage({id:"app.panel.beneficiaryinformationpanel.select.channel"})}`}
                 visible={this.state.showVABrdgx}
                 size={"sm"}
                 onOk ={this.handleDbsAcc}
                 onCancel={this.hideVABrdgx}
          >
            <DbsChannelComponent />
          </Modal>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state =>{
  return {
    currentUser: state.user.currentUser
  }
}

const mapDispatchToProps = dispatch =>{

}

export default withRouter(
    connect(mapStateToProps,mapDispatchToProps) (
        withUseIntl(OriginatorInformationPanel)));

// export default withUseIntl(OriginatorInformationPanel);